import { PayloadAction } from '@reduxjs/toolkit';
import { configRequest } from 'core/services/product';
import { all, call, fork, put, take } from 'redux-saga/effects';
import { IDomain } from 'types/domain/organisation';

function* init() {
  const domain = window.location.host.split('.')[0];

  yield put(yield call(configRequest, domain));
  const action: PayloadAction<IDomain> = yield take([configRequest.fulfilled]);
  const { domainConfig } = action.payload;
  const set = (v: string, val?: string) => val && document.documentElement.style.setProperty(v, val);

  if (domainConfig != null) {
    if (domainConfig?.primaryBtn) {
      set('--theme-accent-dark', domainConfig?.primaryBtn);
      set('--brand', domainConfig.primaryBtn);
    }
    if (domainConfig?.dialogBg) {
      set('--theme-card-bg-dark', domainConfig.dialogBg);
      set('--module-bg', domainConfig.dialogBg);
    }

    if (domainConfig?.dialogText) {
      set('--theme-font-color-dark', domainConfig.dialogBg);
      set('--module-txt', domainConfig.dialogBg);
    }
  }
  //
}

export default function* configSaga() {
  yield all([fork(init)]);
}
